import { CustomerStatus, CUSTOMER_METADATA } from "../constants.js";
export const isCustomerSuspended = (meta) => {
    const customerStatus = meta?.find((m) => m.key === CUSTOMER_METADATA.CUSTOMER_STATUS)?.value;
    return customerStatus === CustomerStatus.SUSPENDED;
};
